'use strict';

import Vue from 'vue';

// Dependency injector
import injector from 'vue-inject';
require('./dependencies');
Vue.use(injector);

// Inview detector
import VueWaypoint from 'vue-waypoint';
Vue.use(VueWaypoint);

import App from './App.vue';

import './assets/css/reset.css';
import './assets/css/font-awesome/css/font-awesome.min.css';

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app');
